import styled from "styled-components";

const DivCenter = styled.div`
  margin-top: ${props => props.marginTop || 0};
  text-align: center;
`;

export default DivCenter;
